import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleGuard } from 'src/app/core/guard/module.guard';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { Modules } from 'src/app/core/model/modules.enum';
import { Privileges } from 'src/app/core/model/privileges.enum';

const routes: Routes = [
  {
     path:"chatbot",
     component:ChatbotComponent,
     canActivate: [ModuleGuard],
     data: { module: Modules.CHATBOT, privilege: Privileges.VIEW_CHATBOT },
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatbotManagementRoutingModule { }